export enum StepIds {
  Details = 'Details',
  Subjects = 'Subjects',
  Assessors = 'Assessors',
  Skills = 'Skills',
  Settings = 'Settings',
  Summary = 'Summary',
}